module.exports = __webpack_public_path__ + "assets/img/1f799f11ed4fdc228f7534bd4777a23a.svg";